function service (dataBrokerService, localStorageService) {
    return {
        getListing
    };

    function getListing() {
        return dataBrokerService.getItem('listing').then(listing => {
            if (listing && listing.listingDetailDto){
                /* istanbul ignore next */
                let userData = JSON.parse(localStorageService.getItem("Cars.userData")) || {};
                userData.listingPrice = listing.listingDetailDto.price;
                localStorageService.setItem("Cars.userData", JSON.stringify(userData));
            }
            return listing;
        });
    }
}

service.$inject = ['dataBrokerService', 'localStorageService'];

export default service;
